@use "foundation/_colors.scss";
@use "foundation/_responsive.scss";

.container {
  display: flex;
  justify-content: center;
  max-width: 35em;
  margin: 2em auto;

  &.inline {
    margin: 0;
    justify-content: unset;
  }

  div[class^="modal"] div[class^="modal-content"] {
    div[class^="header"] {
      max-width: 33em;
      padding: 1.1em 1.7em 1.4em 1.7em;
      h3 {
        // we just want the same font for all screen sizes
        font-size: 20px;
      }

      div[class^="modal-close"] {
        margin-top: 3px;
      }
    }

    div[class^="section"] {
      max-width: 31em;
      padding: 1.4em 1.7em;

      p[class^="platform-suggestion"]:first-child {
        margin-top: 0;
      }
    }
  }
}

.platform-suggestion {
  display: flex;
  align-items: center;
  background: colors.$input-border-color;
  border-radius: 0.5em;
  font-weight: 700;
  padding: 1em 1.7em;
  width: fit-content;

  &.inline {
    background: none;
    padding: 0.875em 0 0 0;
    font-size: 0.875em;
    color: colors.$secondary-text-color;
  }

  @include responsive.phone() {
    flex-direction: column;
    height: auto;

    .suggestion-button {
      margin-top: 0.8em;
      // this is really dumb, but centers the button by compensating for the other override
      margin-right: 1em !important;
    }
  }
}

.suggestion-prompt {
  margin: 1em auto 0.6em auto;
}

.modal-anchor {
  cursor: pointer;
  text-decoration: underline;
  margin: 0 0.5em;
}

.suggestion-button {
  padding: 0.4em 1em;
  margin-left: 1em !important;

  &.protocol {
    margin: 1em auto 0.2em auto !important;
  }
}

.email-me {
  display: flex;
  flex-direction: column;
  align-self: center;
  width: 100%;
  font-size: 0.9em;
  font-weight: 700;
}

.checkbox {
  padding: .8em;
  width: .8em;
  height: .8em;
  line-height: 1em;
  text-align: left;
  transition: all .1s;
  box-sizing: border-box;
  display: inline-block;
  margin-right: 1em;
  vertical-align: middle;
  cursor: pointer;
  background: white;
  border: 5px solid #eee;
  border-radius: 10px;

  svg {
    position: relative;
    left: -.6em;
    top: -.6em;
    stroke: colors.$primary-background-color;
    stroke-width: 2;
  }
}

textarea.noresize {
  resize: none;
}

.margin-bottom {
  margin-bottom: 1.4em;
}

.check-input {
  color: colors.$error-color;
}

.no-globals {
  margin: 0 !important;
  padding: 0.5em 0.75em !important;
  background: none !important;
}

.flex {
  display: flex;
}
